module.exports = __webpack_public_path__ + "resources/img/logo_openstack.8fbd1989df6f06bdff08c4bac2855fb4.png";